import React, { useState } from 'react';

const ProviderKeyValueFields = ({ label, value = {}, onChange, disabled, reservedKeys = [] }) => {
  const [newKey, setNewKey] = useState('');
  const key = newKey.trim();
  const canAdd = key && !Object.hasOwn(value, key) && !reservedKeys.includes(key) && !['__proto__', 'constructor', 'prototype'].includes(key);
  return <div className="ticket-request-form">
    <span className="ticket-muted">{label}</span>
    {Object.entries(value).map(([name, fieldValue]) => <div className="ticket-key-value-row" key={name}>
      <label>{name}<input className="input" value={typeof fieldValue === 'object' && fieldValue !== null ? JSON.stringify(fieldValue) : fieldValue ?? ''}
        disabled={disabled} onChange={event => onChange({ ...value, [name]: event.target.value })} /></label>
      <button type="button" className="btn btn-secondary" disabled={disabled} aria-label={`Remove ${name}`} onClick={() => onChange(Object.fromEntries(Object.entries(value).filter(([field]) => field !== name)))}>Remove</button>
    </div>)}
    <div className="ticket-key-value-row">
      <input className="input" aria-label={`New ${label.toLowerCase()} field name`} placeholder="New field name" value={newKey} disabled={disabled} onChange={event => setNewKey(event.target.value)} />
      <button type="button" className="btn btn-secondary" disabled={disabled || !canAdd} onClick={() => { onChange({ ...value, [key]: '' }); setNewKey(''); }}>Add field</button>
    </div>
  </div>;
};

export default ProviderKeyValueFields;
